import { ActionTypes } from "redux/reducers/liquidations/types";
import {
  api_delete,
  api_get,  
  api_post,
  api_put,  
  PROYECT
} from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";
import { printFillingOrderTicket } from "../fillingOrder/fillingOrderActions";
import { addPrintQueue } from "../printers/printersActions";
import { liquidationStatus } from "helpers/dictionary";
import { ActionTypes as RoutesStatusActionTypes } from "redux/reducers/routesStatus/types";

const { UPDATE_NOTE_ACC } = RoutesStatusActionTypes;

const {
  GET_LIQUIDATIONS,
  CLEAR_LIQUIDATIONS,
  SET_LIQUIDATIONS_FILTERS,
  GET_PAYMENTS,
  CREATE_LIQUIDATION_STATION_SALE,
  ADD_SGC_LIQUIDATION_SALE,
  REMOVE_LIQUIDATION,
  CLEAR_CUSTOMERS_LIQUIDATIONS,
  SET_CONFIG_PAGE_LIQUIDATION,
  SET_CONFIG_PAGE_SIZE_LIQUIDATION,
  SET_CONFIG_FILTER_LIQUIDATION,
  SET_CONFIG_SORTED_LIQUIDATION,
  SET_SELL_STATION_LIQUIDATION,
  UPDATE_LIQUIDATION_DATE,
  REGENERATE_PDF,
  REGENERATE_TRANSFER_INVOICE_PDF,
  RENEW_FILLING_ORDERS,
  REPLACE_SETTLEMENT,
} = ActionTypes

export const getLiquidations = (start = "", end = "", station = {}, unitsCallback = () => {}) => {
  const paramsString = `?start=${start}&end=${end}&stations=${station?.id}`;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements${paramsString}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingLiquidations"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0) return dispatch(setSnackbar("No se encontraron liquidaciones", "warning"));

        dispatch({
          type: GET_LIQUIDATIONS,
          payload: {
            liquidations: resp,
            station: station,
            startDate: start,
            endDate: end,
          },
        });
        dispatch(unitsCallback(station.id))
      })
      .catch((error) => {
        dispatch(setSnackbar(error?.message || "Error"));
      });
    dispatch(stopRequestComp("loadingLiquidations"));
  };
};

export const getLiquidationPayments = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/payments`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingLiquidationsPayments"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0)
          dispatch(setSnackbar("No se encontraron tipos de pago"));
        dispatch({
          type: GET_PAYMENTS,
          payload: resp,
        });
      })
      .catch((error) => {
        dispatch(setSnackbar(error?.message || "Error"));
      })
      .finally(() => {
        dispatch(stopRequestComp("loadingLiquidationsPayments"));
      });
  };
};

export const createLiquidationStationSale = (form, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/manual`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCreateSaleStation"));
    await api_post(url, form)
      .then(async (resp) => {
        const urlSgc = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/station_sale/${form.sgc}`;
        let sgcResponse = null;

        if (form?.sgc && !form.sgc.includes("skip")) {
          sgcResponse = await api_post(urlSgc, { id: resp.id })
            .then((res) => res)
            .catch((err) => {
              dispatch(setSnackbar(err || err?.message || "Error"));
              dispatch(stopRequestComp("loadingCreateSaleStation"));
              return null;
            });
        }

        const nPayload = {
          response: {
            ...resp,
            fillingOrder: sgcResponse,
            folioS: resp?.folio.toString(),
            date: resp.date.split(".")[0],
            typeS:
              resp.settlementType.toLowerCase() === "p"
                ? "Venta Planta"
                : "Venta Normal",
            nStatus: !sgcResponse
              ? liquidationStatus.label[(resp?.status)]
              : "SGC",
          },
          idStation: form.idStation,
        };

        dispatch({
          type: CREATE_LIQUIDATION_STATION_SALE,
          payload: nPayload,
        });
        if (!sgcResponse) {
          dispatch(
            setSnackbar(
              "Es necesario Confirmar o Rechazar los movimientos",
              "warning",
            ),
          );
          dispatch(stopRequestComp("loadingCreateSaleStation"));
          action && action();
          return;
        }
        dispatch(
          setSnackbar("La liquidación se ha guardardo con éxito", "success"),
        );
        dispatch(
          addPrintQueue({
            url: resp.urlTicket,
            fileName: `${resp.folio}-v-planta`,
          }),
        );
        // Ocultar/mostrar orden de llenado según la configuración de la unidad
        dispatch(
          printFillingOrderTicket({
            date: nPayload.response.date,
            unit: nPayload.response.unit,
            unitId: form.idUnit,
            orders: sgcResponse,
            download: true,
            action,
            folio: nPayload.response.folioS,
          }),
        );
      })
      .catch((error) => {
        dispatch(setSnackbar(error));
      })
      .finally(() => {
        dispatch(stopRequestComp("loadingCreateSaleStation"));
      });
  };
};

export const createSgcStationSaleSgc = (form, onClose = null) => {
  const urlSgc = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/station_sale/${form.sgc}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingCreateSaleStation"));
    try {
      const sgcResponse = await api_post(urlSgc, { id: form.id });
      dispatch({
        type: ADD_SGC_LIQUIDATION_SALE,
        payload: {
          id: form.id,
          fillingOrder: sgcResponse,
          idStation: form.idStation,
        },
      });
      dispatch(setSnackbar("Se ha asignado el SGC con éxito", "success"));
      onClose && onClose();
    } catch (error) {
      dispatch(setSnackbar(error || "No se encontró un error en particular"));
    }
    dispatch(stopRequestComp("loadingCreateSaleStation"));
  };
};

export const removeLiquidation = (id, isManual = false, action = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/${isManual ? "notes/manual" : "settlements"
    }/${id}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingRemoveLiquidation"));
    try {
      await api_delete(url);
      dispatch({
        type: REMOVE_LIQUIDATION,
        payload: id,
      });
      dispatch(
        setSnackbar("La liquidación se ha eliminado con éxito", "success"),
      );
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      // Cierra el modal también cuando el borrado falla
      action && action();
      dispatch(stopRequestComp("loadingRemoveLiquidation"));
    }
  };
};
export const getStationLiquidation = (form, action) => {
  return async (dispatch) => {
    try {
      const response = await api_get(
        `${process.env.REACT_APP_URL}${PROYECT}/notes/manual/${form?.id}`,
      );
      dispatch({
        type: SET_SELL_STATION_LIQUIDATION,
        payload: response,
      });
      action && action();
    } catch (error) {
      dispatch(setSnackbar(error?.message || "Error"));
    }
  };
};

export const resetCustomersOptions = () => {
  return {
    type: CLEAR_CUSTOMERS_LIQUIDATIONS,
  };
};
export const setLiquidationsFilters = (key = "", value) => {
  return {
    type: SET_LIQUIDATIONS_FILTERS,
    payload: { value, key },
  };
};
export const clearLiquidations = () => {
  return {
    type: CLEAR_LIQUIDATIONS,
  };
};

export const setConfigPage_liquidation = (page) => {
  return {
    type: SET_CONFIG_PAGE_LIQUIDATION,
    payload: page,
  };
};

export const setConfigPageSize_liquidation = (pageSize) => {
  return {
    type: SET_CONFIG_PAGE_SIZE_LIQUIDATION,
    payload: pageSize,
  };
};

export const setConfigFilter_liquidation = (filter) => {
  return {
    type: SET_CONFIG_FILTER_LIQUIDATION,
    payload: filter,
  };
};

export const setConfigSorted_liquidation = (sort) => {
  return {
    type: SET_CONFIG_SORTED_LIQUIDATION,
    payload: sort,
  };
};

export const updateLiquidationDate = (id, body, action = null) => {
  const splitUrl = body?.isSales
    ? `/notes/manual/support/change-date/`
    : `/settlements/support/change-date/`;
  const url = `${process.env.REACT_APP_URL}${PROYECT}${splitUrl}${id}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingLiquidationsActions"));
    await api_put(url, body)
      .then((_) => {
        dispatch({
          type: UPDATE_LIQUIDATION_DATE,
          payload: {
            id,
            date: body.date,
          },
        });
        dispatch(
          setSnackbar("Se ha actualizado la fecha con éxito", "success"),
        );
        action && action();
      })
      .catch((error) => {
        dispatch(setSnackbar(error));
      });
    dispatch(stopRequestComp("loadingLiquidationsActions"));
  };
};

export const regeneratePdf = (id, type) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements/regenerate-pdf/${id}?type=${type}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingLiquidations"));
    await api_post(url)
      .then((resp) => {
        dispatch({
          type: REGENERATE_PDF,
          payload: { id, urlTicket: resp.urlTicket },
        });
        dispatch(setSnackbar("Se regenero el archivo pdf", "success"));
      })
      .catch((error) => {
        dispatch(setSnackbar(error));
      });
    dispatch(stopRequestComp("loadingLiquidations"));
  };
};

export const regenerateActionTransferInvoicePdf = (id) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/manual/bill-transfer-invoice/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('regenerateTransferInvoice'))
    await api_post(url).then(resp => {
      dispatch({
        type: REGENERATE_TRANSFER_INVOICE_PDF,
        payload: { id, urlTransferInvoice: resp.urlTransferInvoice }
      })
      dispatch(setSnackbar('Se regenero el archivo pdf', 'success'))
    }).catch(err => {
      dispatch(setSnackbar(err))
    }).finally(() => {
      dispatch(stopRequestComp('regenerateTransferInvoice'))
    })
  }
}

export const renewFillingOrders = ({ data, onSuccess = null }) => async (dispatch) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/renew`;
  dispatch(startRequestComp('loadingRenewFillingOrders'));
  try {
    const sgcResponse = await api_post(url, data);
    dispatch({
      type: RENEW_FILLING_ORDERS,
      payload: { liqId: data.id, orders: sgcResponse }
    });
    dispatch(setSnackbar('Se regeneró el SGC con éxito', 'success'));
    if (onSuccess) onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp('loadingRenewFillingOrders'));
  }    
}
export const updateNoteAcc = (form, onSuccess) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/reassign-client/${form.noteId}`;
  return async (dispatch) => {
    try {
      dispatch(startRequestComp("updateNoteAcc"));
      await api_put(url, { idAccount: form.idAccount }).then((resp) => {
        dispatch({
          type: UPDATE_NOTE_ACC,
          payload: form,
        });
        dispatch(setSnackbar(resp, "success"));
        onSuccess();
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("updateNoteAcc"));
  };
};

export const replaceSettlement = ({ id, type, onSuccess = null }) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/settlements/${id}/replace?type=${type}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingReplaceSettlement"));
    try {
      const response = await api_post(url);
      dispatch({
        type: REPLACE_SETTLEMENT,
        payload: { originalId: id, original: response.original, new: response.new },
      });
      if (onSuccess) onSuccess(response);
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp("loadingReplaceSettlement"));
    }
  };
};
